<div class="popup-content">
  <div class="popup-title" translate>
    teacher.cancel-lilate.popup-title
  </div>
  <div class="popup-text" translate>
    teacher.cancel-lilate.popup-text
  </div>
  <div class="lilate-data">
    <div class="exam-date" translate>
      teacher.cancel-lilate.exam-date : {{lilate.start | amLocale: 'en' | amDateFormat:'ddd DD MMM, HH:mm'}}
    </div>
    <div class="examinee-name">
      {{lilate.student.user.first_name}}
      {{lilate.student.user.last_name}}
    </div>
  </div>
  <div class="actions-wrapper">
    <button class="goback-btn" (click)="closeModal()" translate>teacher.cancel-lilate.goback</button>
    <button class="confirm-btn" (click)="cancelLilate()" translate>teacher.cancel-lilate.confirm</button>
  </div>
</div>
